























import {
  BaseResultModel,
  EVENT_BUS,
  SalesPackTabConstants,
  SalesPackTabModel,
  StoreConstants,
  WorkflowJobButtonModel,
  WorkflowJobProcessResultModel,
  WorkflowJobTabModel,
  WorkflowStandardProcessingAction
} from '@/types';
import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import SalesPack from '@/components/workflow/automotive/tabs/shared/SalesPack.vue';
import { SalesPackService } from '@/services/automotive/SalesPackService';
import { Base64Utils } from '@/utils';
import { EventBus } from '@/classes/EventBus';
import { TabsHelper, AutomotiveSalesPackTab } from '@/mixins';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  name: 'PostSalesPackTab',
  mixins: [TabsHelper, AutomotiveSalesPackTab],
  props: {
    isWorkflowJobLocked: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      postSalesPacks: [] as SalesPackTabModel[],
      isTabLoading: true,
      isPreviewing: false,
      isSending: false,
      salesPackRetrievalError: '',
      modalSpinnerPositioning: 'unset',
      authorizeWithOnFido: false
    };
  },
  methods: {
    ...mapActions('workflowJobStore', ['setPostProcessNavigation']),
    async getPostSalesPack(this: any) {
      try {
        this.postSalesPacks = await SalesPackService.getPostSalesPackAsync(this.workflowJobId);
      } catch (error) {
        this.$log(`Error getting ${this.tabDescription}.`);
        this.salesPackRetrievalError = (error as BaseResultModel).notification;
      } finally {
        this.isTabLoading = false;
        this.handleTabsLoaded();
      }
    },
    async previewPostSalesPack(this: any) {
      this.isPreviewing = true;
      const salesPacksToSendForPreview = (this.postSalesPacks as SalesPackTabModel[]).filter((x) => x.include);
      if (this.validateSalesPackDocuments(salesPacksToSendForPreview)) {
        const previewWindow = window.open();
        previewWindow?.document.write(SalesPackTabConstants.SalesPackGeneratingMarkup);
        try {
          const response = await SalesPackService.getPostSalesPackPreviewAsync(
            this.workflowJobId,
            salesPacksToSendForPreview.map((x) => x.documentTypeId)
          );
          Base64Utils.previewBase64(response, previewWindow);
        } catch (error) {
          this.$log(`Error getting ${this.tabDescription} preview.`);
          previewWindow?.close();
        } finally {
          this.isPreviewing = false;
        }
      } else {
        this.isPreviewing = false;
      }
    },
    async signPostSalesPack(this: any) {
      this.isSending = true;
      try {
        const salesPacksToSendForSigning = (this.postSalesPacks as SalesPackTabModel[]).filter((x) => x.include);
        if (this.validateSalesPackDocuments(salesPacksToSendForSigning)) {
          const postProcessResult: WorkflowJobProcessResultModel = await SalesPackService.sendPostSalesPackForSigningAsync(
            this.workflowJobId,
            salesPacksToSendForSigning.map((x) => x.documentTypeId),
            this.authorizeWithOnFido
          );
          if (postProcessResult?.postProcessNavigation) {
            this.setPostProcessNavigation({
              queueId: postProcessResult.postProcessNavigation.queueId,
              jobId: postProcessResult.postProcessNavigation?.jobId
            });
          }

          EventBus.$emit(EVENT_BUS.PROCESS_JOB, {
            processingAction: WorkflowStandardProcessingAction.ProcessJob
          } as WorkflowJobButtonModel);
        } else {
          this.isSending = false;
        }
      } catch (error) {
        this.$log(error);
        this.isSending = false;
      }
    },
    updatePostSalesPackItem(this: any, documentTypeId: number, checked: boolean) {
      const postSalesPackItemIndex = (this.postSalesPacks as SalesPackTabModel[]).findIndex((x) => x.documentTypeId === documentTypeId);
      if (postSalesPackItemIndex > -1) {
        Vue.set(this.postSalesPacks, postSalesPackItemIndex, {
          ...this.postSalesPacks[postSalesPackItemIndex],
          include: checked
        });
      }
    },
    updateOnfido(checked: boolean) {
      this.authorizeWithOnFido = checked;
    }
  },
  computed: {
    ...mapGetters(StoreConstants.WorkflowJob.ModuleName, [StoreConstants.WorkflowJob.Getters.VerticalJobTabs]),
    isSubmitting(this: any) {
      return this.isPreviewing || this.isSending;
    },
    tabDescription(this: any) {
      return (this[StoreConstants.WorkflowJob.Getters.VerticalJobTabs] as WorkflowJobTabModel[]).find((x) => x.componentName === this.$options.name)?.description || 'Sales Pack';
    }
  },
  async mounted(this: any) {
    await this.getPostSalesPack();
  },
  components: {
    LoadingSpinner,
    SalesPack
  },
  created(this: any) {
    this.workflowJobId = Number(this.$route.params.jobId);
  }
});
